PJQ.models.settings.PaymentInfo = PJQ.models.BaseModel.extend({
	idAttribute: "paymentInfoId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'settings'
			},
			{
				endpoint: 'ordering'
			},
			{
				endpoint: 'paymentinfo'
			}
		])
	},
	afterInit: function () {
		this.set({
			companyName: '',
			cardholderName: '',
			address1: '',
			address2: '',
			city: '',
			state: '',
			zip: '',
			country: '',
			phone: '',
			phoneExt: '',
			email: '',
			cardNumber: '',
			expMonth: '',
			expYear: ''
		});
	},
});

PJQ.models.settings.PlanRoomSettings = PJQ.models.BaseModel.extend({
	defaults: {
		type: 'planroom'
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'settings'
			},
			{
				endpoint: 'planroom'
			}
		])
	},
	parse: function (model) {
		if (!model)
			return model;
		this.projectStatuses = new PJQ.collections.settings.ProjectStatuses(model.projectStatuses);
		this.messageStatuses = new PJQ.collections.settings.MessageStatuses(model.messageStatuses);
		return model
	}
});

PJQ.models.settings.OrderingSettings = PJQ.models.BaseModel.extend({
	defaults: {
		type: 'ordering'
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'settings'
			},
			{
				endpoint: 'ordering'
			}
		])
	}
});

PJQ.models.settings.AddressBookSettings = PJQ.models.BaseModel.extend({
	defaults: {
		type: 'address-book'
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'settings'
			},
			{
				endpoint: 'addressbook'
			}
		])
	}
});

PJQ.collections.settings.ProjectStatuses = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.settings.PlanRoomSettings
});

PJQ.collections.settings.MessageStatuses = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.settings.PlanRoomSettings
});
